module.exports = __webpack_public_path__ + "static/JetBrainsMono-Bold-55c1134aa19a9745b9ec647d28d41532.woff";